import { Radius } from "../types";

export const getRadius = (radius?: Radius) => {
  switch (radius) {
    case 'none':
      return 'var(--borderRadiusNone)'
    case 'rounded':
      return 'var(--borderRadiusBase)'
    case 'full':
      return 'var(--borderRadiusFull)'
    default:
      return radius
  }
}